import { Modal } from "@assetwatch/ui";
import { useTranslation } from "react-i18next";

export function MotionAmplificationRawVideoModal({
  open,
  title,
  videoUrl,
  onOpenChange,
}: {
  open: boolean;
  title: string;
  videoUrl: string | null;
  onOpenChange: (open: boolean) => void;
}) {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      size="lg"
      title={`${t("motionAmplification.viewRawVideo")} • ${title}`}
    >
      {videoUrl && (
        <video
          controls
          preload="metadata"
          className="aspect-video w-full"
          src={videoUrl}
        >
          <track kind="captions" />
        </video>
      )}
    </Modal>
  );
}
